import * as React from "react";
import { ImagesContext } from "../Context";

interface Props {
  isBadgeShowing: boolean;
}

const LoadingReportsTable: React.FC<Props> = ({ isBadgeShowing }) => {
  const images = React.useContext(ImagesContext);

  return (
    <div
      className="loading-container"
      style={{ height: isBadgeShowing ? "50vh" : "58.8vh" }}
    >
      <img alt="Loading" src={images.new_large_spinner_src}></img>
      <h3>Loading...</h3>
      <p>
        We are loading your reports.
        <br />
        This might take a few minutes. Please do not leave this page.
      </p>
    </div>
  );
};

export default LoadingReportsTable;
